module.exports = __webpack_public_path__ + "img/5.c656c590.png";